import { fork, all } from 'redux-saga/effects';

import * as DynamicElement from './DynamicElement';

export default function* rootSaga() {
  yield all([...Object.values(DynamicElement)].map(fork));
}
